import classnames from 'classnames';
import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../../store/charts/chartsStore';
import { popupActions } from '../../../store/popupStore';
import { SECTIONS } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { generate as generateReportLinks, renderLink } from '../../common/reportLinks';

import '../relationChart.scss';
import '../relationChartFonts.scss';

import PortfolioIcon from '../../../img/icons/BBiconsPridatDoPortfolia';

class ChartContextMenu extends React.Component {
    render() {
        const { contextMenu } = this.props.charts;

        if (isNullOrUndefined(contextMenu))
            return null;

        const { show, context } = contextMenu;

        var extraClass = '';
        var linkClass = 'report-link';
        if (localStorage.getItem('locales_report_buttons_format') === 'short') {
            extraClass = 'w43';
            linkClass += ' w43';
        }
        return (
            <div id="entityContextMenu" className={classnames("entity-hover-popup", 'noborder', { 'report-links': show })}
                style={{
                    display: show ? 'flex' : 'none', top: `${context.position.y}px`, left: `${context.position.x}px`,
                    transform: 'translate(-100%, -100%)', maxWidth: `${context.maxWidth}px`, backgroundColor: context.coloring
                }} ref={el => {
                    if (!el || !show) return;
                    var rect = el.getBoundingClientRect();
                    var parent = document.getElementById("diagramPlane").getBoundingClientRect();
                    if (rect.y < parent.y) {
                        el.style.top = (context.position.y + rect.height + 5) + "px";
                        if ((context.position.x + context.maxWidth + 5) > (parent.right))
                            el.style.left = (context.position.x - (context.maxWidth + 5)) + "px";
                        else
                            el.style.left = (context.position.x + context.maxWidth + 5) + "px";
                    }
                }}>
                {show && generateReportLinks(context.entityId, context.reports, false).map(link =>
                    renderLink(link.url, link.translationKey, true, link.primaryAttr, true, this.props.translate, extraClass, true, null, link.type, this.props)
                )}
                {show && context.entityType !== "AD" && <a href={`/search/results?type=bs&isPo=${context.entityType === "PO" || context.entityType === "FOP"}&q=${encodeURIComponent(context.entityName)}`} className={linkClass} target="_blank" title={this.props.translate('Charts.Search')}>
                    <span className="rc-button rc-search-gray-btn" style={{ transform: 'translateY(3px)' }} />
                </a>}
                {show && <a onClick={() => this.showSubjectIdInformation(context.entityId, context.entityType)} className={linkClass} title={this.props.translate('Charts.Report.BasicInfo.LongName')}>
                    <span className="rc-button rc-info-gray-btn" style={{ transform: 'translateY(2px)' }} />
                </a>}
                {show && context.entityType !== "AD" && <a onClick={() => this.openPortfolioPopup(context)} className={linkClass} title={this.props.translate('Monitoring.Add.AddToPortfolio')}>
                    <PortfolioIcon className='rc-add-portfolio-btn' />
                </a>}
                {show && context.hasWarnings && context.entityType !== "AD" && <a href="javascript:void(0)" onClick={() => this.showSubjectWarnings(context.entityId, context.entityType)} className={linkClass} title={this.props.translate('Charts.Report.NegativeInformation.LongName')}>
                    <Translate id={localStorage.getItem('locales_report_buttons_format') === 'short' ? 'Charts.Report.NegativeInformation.ShortName' : 'Charts.Report.NegativeInformation.LongName'} />
                </a>}
            </div>
        );
    }

    showSubjectIdInformation = (entityId, entityType) => {
        var url = '';
        if (entityType === "AD")
            url = "/unlimited/quickAddress/" + entityId + `/${SECTIONS.quickAddressReport}|${SECTIONS.quickAddressReportRelations}`;
        else
            url = "/unlimited/quick/" + entityId + `/${SECTIONS.quickReport}|${SECTIONS.quickReportRelations}`;
        window.open(url, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
    }

    showSubjectWarnings = (entityId, entityType) => {
        window.open(`/warnings/${entityId}`, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10");
    }

    openPortfolioPopup = (context) => {
        this.props.showPopup("addToPortfolioPopup", {
            open: true,
            subject: {
                type: context.entityType === "PO" || context.entityType === "FOP" ? 1 : 2,
                name: context.entityName,
                entityId: context.entityId,
                reports: context.reports,
                ico: context.ico,
                dateOfBirth: context.dateOfBirth,
                dateOfBirthFormated: context.dateOfBirthFormated,
                address: context.address
            },
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        })
    }
}

export default withRouter(withLocalize(connect(
    state => ({ charts: state.charts }),
    dispatch => bindActionCreators({ ...chartActions, ...popupActions, }, dispatch)
)(ChartContextMenu)));